import { render, staticRenderFns } from "./ResultsArchitecture.vue?vue&type=template&id=2e99ec26&"
import script from "./ResultsArchitecture.vue?vue&type=script&lang=js&"
export * from "./ResultsArchitecture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports